import React from 'react';

import styles from './dictionary-components.module.scss';

export default function AkGreenCheckmark() {
    return <i className={`material-icons ${styles.akGreen}`}>check</i>;
}
